import {useEffect, useRef} from 'react';
import {sendHomeExtra} from './useHomePageView';
import useTypedSelector from '../../../common/hook/useTypedSelector';

export default function useHomeSendExtra({
  listCount,
  canSendExtra,
  customProps,
}: {
  listCount: number;
  canSendExtra: boolean;
  customProps?: {[key in string]: string | number};
}) {
  const [tabPage, secondTab] = useTypedSelector(({home}) => [
    home.tabPage,
    home.secondTabs[home.tabPage].selected,
  ]);
  const customPropsRef = useRef(customProps);

  useEffect(() => {
    customPropsRef.current = customProps;
  });

  useEffect(() => {
    canSendExtra &&
      listCount > 0 &&
      sendHomeExtra({
        tabPage,
        secondTab,
        customProps: {
          list_num: listCount,
          ...customPropsRef.current,
        },
      });
  }, [canSendExtra, listCount, tabPage, secondTab]);
}
